// extracted by mini-css-extract-plugin
export default {"wrapper":"mdhq-links_wrapper__G-5Xr","linksBlock":"mdhq-links_linksBlock__M6vRa","links":"mdhq-links_links__gxV9L","link":"mdhq-links_link__mTQlx"};